module.exports = {
      id: "selected-usage",
      viewBox: "0 0 57 56",
      url: __webpack_public_path__ + "sprite.b16108e5f95a8323b5a812454e446fa5.svg#selected-usage",
      toString: function () {
        return this.url;
      }
    }